import React from 'react'
import Popover from '../Popover'
import ButtonBase from '../ButtonBase'
import InfoIcon from '../../assets/svgs/info.svg'
import PropTypes from 'prop-types'
import './TooltipInfo.scss'

/** Tooltip info  */
const TooltipInfo = ({ popoverClass, children, trigger, className, label, ...rest }) => (
  <div className={`Suc-tooltip-info-container ${className}`}>
    {label &&
    <label>
      {label}
    </label>}
    <Popover
      popoverClass={`Suc-tooltip-info ${popoverClass}`}
      trigger={trigger}
      containerClass='Suc-info-button'
      container={
        <ButtonBase type='button'>
          <InfoIcon/>
        </ButtonBase>
      }
      {...rest}
    >
      {children}
    </Popover>
  </div>
)

TooltipInfo.propTypes = {
  /** popover trigger */
  trigger: PropTypes.oneOf(['hover', 'click']),
  /** popover custom classname */
  popoverClass: PropTypes.string,
  /** trigger element custom classname */
  className: PropTypes.string,
  /** label */
  label: PropTypes.node,
  /** preferred placement of the tooltip */
  placement: PropTypes.oneOf(['top', 'right', 'left', 'bottom'])
}

TooltipInfo.defaultProps = {
  className: '',
  popoverClass: '',
  trigger: 'hover'
}

export default TooltipInfo
